<template>
  <el-link type="primary" v-if="can" class="link-user-container" @click="handleClick">{{ name }}</el-link>
  <span v-else>{{ name }}</span>
</template>

<script>
import {getUserDetail} from "@/api/user";
import {getAuthUser} from "@/utils/auth";

const userAuth = getAuthUser()
const permissions = localStorage.getItem('userAuth') ? JSON.parse(localStorage.getItem('userAuth')).value : {}

export default {
  name: "LinkUser",
  props: {
    name: {
      type: String,
      required: true
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      can: false,
    }
  },
  created() {
    this.setCan();
  },
  methods: {
    setCan() {
      const {organization} = userAuth
      const {can_see_adv_order_all} = permissions
      if (can_see_adv_order_all) {
        // 可以查看全部订单
        this.can = true;
      } else {
        // 组长还是组员
        this.can = (!!organization) && (!!organization.bool_leader)
      }
    },
    /**
     * 获取用户信息
     * @returns {Promise<*>}
     */
    getDetail: async function () {
      const {model} = await getUserDetail(this.id)
      return model
    },
    /**
     * 跳转用户订单页面
     * @returns {Promise<void>}
     */
    handleClick: async function () {
      const user = await this.getDetail()
      let sex = '她', organization_name = ''
      if (user && user.sex) {
        sex = '他'
      }
      const {organization} = userAuth
      if (organization && organization.bool_leader && userAuth.id != this.id) {
        organization_name = userAuth.organization_name || ''
      }

      await this.$router.push({
        query: {sex, organization_name, id: eval(`${this.id}`), name: this.name},
        name: 'SomeoneOrders'
      })
    }
  }
}
</script>

<style lang="scss">
.link-user-container {
  color: #ff3176;
}
</style>
